import script from "./AdminHelp.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminHelp.vue?vue&type=script&setup=true&lang=js"

import "./AdminHelp.vue?vue&type=style&index=0&id=6d436543&lang=css"

const __exports__ = script;

export default __exports__